<script>
import Update from "@/components/Account/Phones/Update";
import Create from "@/components/Account/Phones/Create";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Create,
    Update
  },
  data() {
    return {
      updatePhoneModalVisibility: false,
      createPhoneModalVisibility: false,
      selectedPhone: {}
    };
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  filters: {
    formatedPhone(phone) {
      return `(${phone.area_code}) ${phone.number}`;
    }
  },
  async mounted() {
    this.setAccountId(this.account.id);
    await this.listAccountPhones();
  },
  computed: {
    ...mapState("phones", ["phones"])
  },
  methods: {
    ...mapActions("phones", ["listAccountPhones", "setAccountId"]),
    openUpdateDialog() {
      this.updatePhoneModalVisibility = true;
    },
    openCreateDialog() {
      this.createPhoneModalVisibility = true;
    },
    closeUpdateDialog() {
      this.updatePhoneModalVisibility = false;
    },
    closeCreateDialog() {
      this.createPhoneModalVisibility = false;
    },
    setPhone(phone) {
      this.selectedPhone = phone;
    }
  }
};
</script>

<template>
  <div>
    <Update
      v-if="updatePhoneModalVisibility"
      :phone="selectedPhone"
      :dialog="updatePhoneModalVisibility"
      @close="closeUpdateDialog()"
      @refresh="listAccountPhones()"
    />

    <Create
      :account="account"
      :dialog="createPhoneModalVisibility"
      @close="closeCreateDialog()"
      @refresh="listAccountPhones()"
    />
    <v-sheet class="mx-auto" max-width="70%">
      <v-slide-group multiple show-arrows>
        <v-slide-item v-for="phone in phones" :key="phone.id">
          <v-btn
            class="mx-2"
            active-class="purple white--text"
            depressed
            rounded
            @click="setPhone(phone), openUpdateDialog()"
          >
            {{ phone | formatedPhone }}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
    <v-btn
      class="mx-2"
      active-class="purple white--text"
      color="primary"
      depressed
      rounded
      @click="openCreateDialog()"
    >
      Adicionar Telefone
    </v-btn>
  </div>
</template>

<style scoped>
div {
  display: flex;
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Account/Phones/Index.vue